import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const ChevronArrowLeftIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 11 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M1.26394 10L10.8465 0.853702C11.051 0.658522 11.0512 0.34194 10.8469 0.146595C10.6425 -0.0487489 10.3111 -0.0488821 10.1066 0.146298L0.153459 9.6463C-0.0511531 9.84159 -0.0511531 10.1584 0.153459 10.3537L10.1066 19.8537C10.3111 20.0489 10.6425 20.0487 10.8469 19.8534C11.0512 19.6581 11.051 19.3415 10.8465 19.1463L1.26394 10Z' />
    </svg>
  )
}
